import { useCallback, useState, useEffect, useMemo } from 'react';

import { ISelectProps } from 'components/Select/Select';
import useFinanceSettings from 'hooks/useFinanceSettings';
import { FilterCategory } from 'config/constants';
import financeSettingsStore from "stores/financeSettings"
import toastMessages from 'stores/toastMessages';



export default function useCostCategoryOptions(currentFilterCategory: FilterCategory) {

    const { costCategories } = useFinanceSettings()
    const [loading, setLoading] = useState(false)

    const fetchCostCategories = useCallback(async () => {
        setLoading(true)
        try {
            await financeSettingsStore.fetchCostCategories()
        } catch (e) {
            toastMessages.showSystemError()
        }
        setLoading(false)
    }, [])

    useEffect(() => {
        if (currentFilterCategory !== FilterCategory.costCategory || costCategories) return
        fetchCostCategories()

    }, [costCategories, currentFilterCategory, fetchCostCategories])

    const costCategoriesOptions = useMemo<ISelectProps["options"]>(() => {
        return costCategories?.list.map(cc => ({
            label: cc.costCategoryLedgerAccount ? `${cc.costCategoryLedgerAccount} (${cc.costCategoryName})` : cc.costCategoryName,
            value: cc,
        }))
    }, [costCategories])

    return { costCategoriesOptions, isLoadingCostCategories: loading }

}
